"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightIsActiveEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CheckBox_1 = require("../../../CheckBox");
const FlightIsActiveEditor = (props) => {
    const { field } = props;
    const fieldProps = {
        name: 'isActive',
        modificators: field.modifiers,
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Active', defaultMessage: 'Active' })),
        error: field.error,
        checked: field.input,
        onChange: field.onEvent,
    };
    return (react_1.default.createElement(CheckBox_1.CheckBox, { ...fieldProps }));
};
exports.FlightIsActiveEditor = FlightIsActiveEditor;
//# sourceMappingURL=FlightIsActiveEditor.js.map